<!-- =========================================================================================
  File Name: SigepTabEquivalents.vue
  Description: Sigep Equivalents Tab content
========================================================================================== -->
<template>
  <vs-alert active="true" class="mb-10" v-if="data_local.hasOwnProperty('services') && data_local.services instanceof Array">
    Favor preencher as suas credenciais na aba <code>Informações</code> para exibição das equivalências configuradas para seu cartão de postagem do SIGEP
  </vs-alert>
  <div id="sigep-tab-equivalents" class="data-list-container" v-else>
    <p class="mb-5">
      A lista de equivalências serve para definir <code>qual tipo de envio</code> você vai querer <code>independente</code> do que foi escolhido pelo cliente.
    </p>
    <vs-alert active="true" class="mb-5">
      <span></span>
      <span>Por exemplo, caso o cliente tenha escolhido SEDEX mas você envia sempre por PAC, <code>é possível</code> fazer essa configuração.</span>
    </vs-alert>
    <p class="mb-5">
      Para implementar o exemplo acima, clique em <code>+Nova</code>, depois em <code>Código de Envio</code> coloque 04014 (código do SEDEX sem contrato) e em <code>Se transforma em</code> escolha sua modalidade de PAC.
    </p>
    <p class="mb-10">
      Qualquer dúvida entre em contato conosco via e-mail para <code>support@gadolapps.com</code>
    </p>
    <sigep-tab-equivalents-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />
    <vs-table ref="table" hoverFlat :data="data_local.equivalents">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- ADD NEW -->
          <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Nova</span>
          </div>
        </div>
      </div>
      <tbody>
        <vs-tr v-for="(item, key, index) in data_local.equivalents" :key="index">
          <vs-td>
            <p>{{ key === '_default' ? 'Todas modalidades que não existirem se tornam' : `Modalidade ${key} se torna` }}</p>
          </vs-td>
          <vs-td>
            <p>{{ typeof data_local.services[item] === 'string' || data_local.services[item] instanceof String ? data_local.services[item] : typeof data_local.services[item] == 'undefined' ? '' : data_local.services[item].descricao }}</p>
          </vs-td>
          <vs-td class="whitespace-no-wrap text-align-right">
            <feather-icon icon="EditIcon" title="Alterar" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(key,item)" />
            <feather-icon icon="TrashIcon" title="Remover" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(key)" v-if="key !== '_default'" />
          </vs-td>
        </vs-tr>
      </tbody>
    </vs-table>
  </div>  
</template>
<script>
import SigepTabEquivalentsSidebar from './SigepTabEquivalentsSidebar.vue'


export default {
  components: {
    SigepTabEquivalentsSidebar
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {

      data_local: this.$store.state.sigep.info,
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},

    }
  },
  computed: {



  },
  methods: {

    addNewData() {
      this.sidebarData = { services: this.data_local.services, equivalents: this.data_local.equivalents }
      this.toggleDataSidebar(true)
    },

    deleteData(key) {


      this.$vs.loading();

      delete this.data_local.equivalents[key]

      let info = JSON.parse(JSON.stringify(this.$store.getters['sigep/info']))
      info["equivalents"] = this.data_local.equivalents;

      delete info.remetente.valid;


      this.$store.dispatch("sigep/updateCreds", info)
        .then(() => {

          this.$vs.notify({
            title: 'Tudo certo!',
            text: 'Equivalência alterada!',
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-check'
          })

          this.$vs.loading.close();
          this.data_local = JSON.parse(JSON.stringify(this.$store.getters['sigep/info']))

        })
        .catch(() => {
          // console.error(err) 

          this.$vs.notify({
            title: 'Erro',
            text: 'Ocorreu um erro, por favor tente novamente!',
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })

          this.$vs.loading().close();

        })




    },
    editData(key, item) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = { services: this.data_local.services, equivalents: this.data_local.equivalents, key: key, val: item }
      this.toggleDataSidebar(true)
    },

    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val
      this.data_local = JSON.parse(JSON.stringify(this.$store.getters['sigep/info']))
    }

  },
}

</script>
<style lang="scss">
#sigep-tab-equivalents {
  .vs-con-tbody {
    border: 0px;
  }

  .text-align-right {
    text-align: right;
  }

}

</style>
